module.exports = __webpack_public_path__ + "img/tree-02-b-trunk.52488505.png";